<script>
  import { createEventDispatcher } from 'svelte'
  import { TriangleIcon, TickIcon } from './icons'

  export let placeholder = ''
  // value could be either string or object
  export let value
  // options could a list of strings or objects with keys `value` & `label`
  export let options = []
  export let displayedItems = 4
  export let dataCy

  let optionsElem
  let expanded = false

  const dispatch = createEventDispatcher()

  function toggleExpansion() {
    expanded = !expanded
  }

  function shrink() {
    expanded = false
  }

  $: selected = Boolean(value)
  $: normalizedOptions = options.map((option) => {
    if (typeof option === 'string') {
      return ({ value: option, label: option })
    }
    return option
  })

  // options list auto-scroll
  $: {
    if (optionsElem && expanded) {
      if (!selected || normalizedOptions.length <= displayedItems) {
        optionsElem.scrollTop = 0
      } else {
        for (let i = 0; i < normalizedOptions.length; i++) {
          if (normalizedOptions[i].value === value) {
            optionsElem.scrollTop = Math.min(i, normalizedOptions.length - displayedItems) * 48
            break
          }
        }
      }
    }
  }
</script>

<style>
  .select {
    position: relative;
    z-index: 100;
  }

  .select .controller {
    background: #ffffff;
    border: 1px solid #b1b5b9;
    border-radius: 4px;
    box-sizing: border-box;
    line-height: 48px;
    height: 48px;
    width: 100%;
    padding-left: 16px;
    position: relative;
    font-size: 16px;
  }

  .select .controller .icon {
    position: absolute;
    right: 14px;
    display: inline-block;
  }

  .select.expanded .controller {
    border-color: #007bb3;
    border-width: 2px;
    border-bottom-width: 1px;
  }

  .select.null .controller {
    color: #999;
  }

  .select .options {
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 4px;
    border: 2px solid #007bb3;
    border-top-width: 1px;
    position: absolute;
    left: 0;
    right: 0;
    overflow-y: scroll;
    transition: all .3s ease;
  }

  .select .options .option {
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    padding-left: 16px;
    cursor: pointer;
    position: relative;
  }

  .select .options .option:hover {
    color: #007bb3;
  }

  .select .options .option .icon {
    position: absolute;
    right: 18px;
    display: inline-block;
  }
</style>

<svelte:body on:click={shrink} />

<div
  data-cy={dataCy}
  class="select"
  class:expanded
  class:null={!selected}
  on:click|stopPropagation={toggleExpansion}
>
  <div class="controller noselect">
    <span
      class="value">{selected ? normalizedOptions.find((option) => (option.value === value || (option.value.isVip && value.isVip)))?.label === undefined ? placeholder :  normalizedOptions.find((option) => (option.value === value || (option.value.isVip && value.isVip)))?.label : placeholder }</span>
    {#if !expanded}
      <div class="icon">
        <TriangleIcon />
      </div>
    {/if}
  </div>
  <div
    class="options"
    style={`height: ${expanded ? 48 * Math.min(normalizedOptions.length, displayedItems) : 0}px; ${expanded ? '' : 'border-width: 0;'}`}
    bind:this={optionsElem}
  >
    {#each normalizedOptions as option}
      <div
        class="option"
        on:click={() => dispatch('input', option.value)}
      >
        <span class="value">{option.label}</span>
        {#if option.value === value}
          <div class="icon">
            <TickIcon />
          </div>
        {/if}
      </div>
    {/each}
  </div>
</div>